<template>
     <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
            Parcializar cargo
          </h4>
        </template>


        <div class="con-form">
          <vs-row>
            <vs-col vs-justify="center" vs-align="center" w="6">
              <h6>Monto</h6>
                <p class="d-flex">{{ monto | currency }} 
                  <vs-tooltip v-if="montoTotal !== monto">
                      <i class="fas fa-exclamation-circle ml-1"></i>
                    <template #tooltip>
                      Las suma de las parcialidades no coinciden con el monto
                    </template>
                  </vs-tooltip>
                </p>
            </vs-col>
            <vs-col vs-justify="center" vs-align="center" w="6">
              <label for="parcialidad">
                Parcialidades 
              </label>
              <vs-input
                type="number"
                v-model="parcialidades"
                required="required"
                id="parcialidad"
                name="parcialidad"
                :disabled="!Boolean(monto)"
                @input="fraccionarMonto()">
              </vs-input>
            </vs-col>
          </vs-row>
        </div>
         <vs-row v-for=" n in parseInt(parcialidades) || 0 " :key="n">
            <vs-col vs-justify="center" vs-align="center" w="6">
              <label :for="`pago_${n}`">
                {{`Pago ${n}`}}
              </label>
              <vs-input
                v-model="pagos[n]"
                type="number"
                required="required"
                :id="`pagos_${n}`"
                :name="`pagos[${n}]`"
                :disabled="!Boolean(monto)"
                step="0.01"
                min="1"
                :max="maxAmounts[n]"
                @input="onChangeAmount(n)">
                <template #message-danger v-if="errorFields.includes(`pagos_${n}`)">
                    Requerido
                </template>
              </vs-input>          			
          </vs-col>
          <vs-col vs-justify="center" vs-align="center" w="6">
            <label :for="`vigencias_${n}`">
              Vigencia
            </label>
            <vs-input
              v-model="vigencias[n]"
              type="date"
              required="required"
              :id="`vigencias_${n}`"
              :name="`vigencias[${n}]`"
              :disabled="!Boolean(pagos[n])"
            >
            <template #message-danger v-if="errorFields.includes(`vigencias_${n}`)">
              Requerido
            </template>
            </vs-input>
          </vs-col>
         </vs-row>

        <template #footer>
          <div class="footer-dialog">
            <vs-button :disabled="montoTotal !== monto" block class="color-blue" @click="guardarParcialidades">
              Guardar  
            </vs-button>           
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import cobranza from '../../../../api/requests/cobranza-persona.js'

export default {
    props:[
      'value',
      'row',
      'institucion'  
    ],
    data () {
        return {
            active: false,
            parcialidades : 1,
            reglaCobro: null,
            reglasCobro: [],
            dataEditar: {},
            maxAmounts: [],
            vigencias: [],
            pagos : [],
            nombre: '',
            monto: 0,
            errorFields: [],
            montoTotal: ''
        }
    },
    methods: {      
      fraccionarMonto () {
            const montoParcial = parseFloat(this.monto)/parseInt(this.parcialidades)
            this.pagos = []
            this.maxAmounts = []
            const oldDates = this.vigencias
            this.vigencias = []
            for (let i = 1; i <= parseInt(this.parcialidades); i++) {
                this.pagos[i] = parseFloat(parseFloat(montoParcial).toFixed(2))
                this.maxAmounts[i] = Math.ceil((this.monto/this.parcialidades)*100)/100
                this.vigencias[i] = this.checkByType ('date', oldDates[i]) 
                ? oldDates[i] 
                : null
            }
        },
      onChangeAmount (evt) {
            const max = parseFloat(parseFloat(this.maxAmounts[evt]).toFixed(2))
            const pago = parseInt(evt)
            const monto = parseFloat(parseFloat(this.pagos[evt]).toFixed(2))
            // if (monto > max){
            //     this.pagos[evt] = max
            // } else if (pago === 0) {
            //     this.pagos[evt] = 1
            // }
        },
      getMaxAmounts (pagos) {
            let total = 0
            for (let n = 1; n <= this.parcialidades; n++) {
                total += parseFloat(pagos[n] || 0);
            }
            this.montoTotal = total
            if (this.parcialidades > 1){
                for (let i = 1; i <= this.parcialidades; i++) {
                    this.maxAmounts[i] = parseFloat(parseFloat(this.monto - ( total - parseFloat(parseFloat(pagos[i] || 0).toFixed(2)) )).toFixed(2));
                }
            } else {
                this.maxAmounts[1] = this.monto
            }
      },
      async guardarParcialidades () {   
            const parciales = []  
            this.errorFields = this.sanityForm ()
            if (!this.errorFields.length && this.row && this.row.id && this.pagos) {
              this.pagos.forEach((element , index ) => {
                const e = {
                  "monto": element,
                  "fecha_vencimiento": this.vigencias[index],
                  "orden": index
                }
                parciales.push(e) 
              });

              try {
                    const loading = this.$vs.loading()
                    let params = {
                        cargo: this.row.id ,
                        parciales: parciales
                    }
                    const { data: response = null } = await cobranza.postParcializar(params) || {}
                    if (response && response.errors && Array.isArray(response.errors)){
                        const data = response.errors.filter(e => Boolean(e))
                        if (data.length){
                            loading.close()
                            data.forEach(element => {
                                this.$vs.notification({
                                    progress: 'auto',
                                    color: 'danger',
                                    position: null,
                                    title: 'Error',
                                    text: element
                                })
                            });
                        }
                    }else {
                      this.pagos = []
                      this.vigencias = []
                      this.parcialidades = 1
                      this.monto = 0
                      loading.close()
                      this.active = false

                      this.$vs.notification({
                          progress: 'auto',                           
                          color: 'success',
                          position: null,
                          title: 'Éxito',
                          text: 'Se parcializó correctamente'
                      })
                      this.$emit('refreshTable')
                    }


                } catch (error) {
                  loading.close()
                   if (error.response.data && error.response.data.errors){
                      const data = error.response.data.errors
                      data.forEach(element => {
                          this.$vs.notification({
                              progress: 'auto',
                              color: 'danger',
                              position: null,
                              title: 'Error',
                              text: element
                          })
                      });

                  }else{
                      this.$vs.notification({
                      progress: 'auto',
                      color: 'danger',
                      position: null,
                      title: 'Error',
                      text: `Algo salió mal`
                      })
                  }
                }
            }
          
      },
      checkByType (type, val) {
        switch (type) {
            case 'string':
                if (val && val.constructor.name === 'String' && val.trim()) {
                    return true
                }
            case 'number':
                if (val && val.constructor.name === 'Number' && val > 0) {
                    return true
                } 
            case 'array':
                if (Array.isArray(val) && val.length){
                    return true
                }
            case 'date':
              if (val && val.constructor.name === 'String' && val.trim()) {
                const date = new Date(val)
                if (Object.prototype.toString.call(date) === "[object Date]"){
                  if (!isNaN(date.getTime())){
                    return true
                  }
                }
              }
              

        }
        return false
      },
      sanityForm () {
            const errorPagos = Array.isArray(this.pagos)
            ? this.pagos.map( (element, index)  => {
              if (index !== 0){
                if (!this.checkByType ('string', element) || element <= 0) {
                  return `pagos_${index}`
                }
              }
              return null
            })
            : []
            const errorVigencia = Array.isArray(this.vigencias)
            ? this.vigencias.map( (element, index)  => {
              if (index !== 0){
                if (!this.checkByType ('date', element)) {
                  return `vigencias_${index}`
                }
              }
              return null
            })
            : []
            return ([...errorPagos, ...errorVigencia]).filter(e=>Boolean(e))
        }

    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        },
        pagos (val) {
            this.getMaxAmounts(val)
        },
        reglaCobro (val){
            if (!this.pagoParcial){
                this.pagos = []
                this.parcialidades = 1
                this.monto = 0
            }
            if (val) {
                this.getMonto()
            }
        },
        pagoParcial (val) {
            this.dataEditar = {...val, editado: true}
            this.institucion = val.regla_cobro.institucion_id
            this.reglaCobro = val.regla_cobro_id
            this.parcialidades = val.parcialidades
            this.nombre = val.nombre
            for (let i = 0; i < val.parcialidades_cargos.length; i++) {
                this.pagos[i+1] = val.parcialidades_cargos[i].monto
                this.vigencias[i+1] = val.parcialidades_cargos[i].vigencias
            }
        },
        parcialidades (val) {
          if (val <= 0 ) {
            this.parcialidades = 1
          }
          this.fraccionarMonto()
        },
        row( val ) {
          this.monto = parseFloat(val.saldo)
          this.parcialidades = 1
          this.pagos = []
          this.pagos[1] = val.saldo
          this.vigencias = []
          this.vigencias[1] = null
        }
    }
}
</script>

<style lang="scss"  scoped >
.color-blue {
  background-color: #005aa3;
}
</style>